/** Match backend sensor slot logging: only trust telemetry after recent DEVICE_DATA. */
export const SENSOR_TELEMETRY_MAX_AGE_MS = 2 * 60 * 1000;

function lastDeviceDataTimeMs(device) {
  if (!device) {
    return null;
  }
  const raw = device.lastDeviceDataAt ?? device.last_device_data_at;
  if (raw == null) {
    return null;
  }
  const ts = raw instanceof Date ? raw.getTime() : new Date(raw).getTime();
  return Number.isNaN(ts) ? null : ts;
}

/**
 * Stale if last_device_data_at is missing or older than SENSOR_TELEMETRY_MAX_AGE_MS.
 * Does not use updatedAt (status-only bumps must not refresh displayed readings).
 */
export function isSensorTelemetryStale(device, nowMs = Date.now()) {
  const ts = lastDeviceDataTimeMs(device);
  if (ts == null) {
    return true;
  }
  return nowMs - ts > SENSOR_TELEMETRY_MAX_AGE_MS;
}
